// extracted by mini-css-extract-plugin
export default {"section":"Projects_section__lRz5q","inner":"Projects_inner__rXzdz","grid":"Projects_grid__t+2t-","cell":"Projects_cell__4IB35"};